import { render, staticRenderFns } from "./CustomerLocationsMap.vue?vue&type=template&id=0bf630c1&scoped=true&"
import script from "./CustomerLocationsMap.vue?vue&type=script&lang=js&"
export * from "./CustomerLocationsMap.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLocationsMap.vue?vue&type=style&index=0&id=0bf630c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf630c1",
  null
  
)

export default component.exports